import React from 'react';
import PageRoutes from './Routes';

function App() {

  return (
    <PageRoutes/>
  );
  
}

export default App;
